import IBaseComponent from '@components/FormFlow/Interfaces/Base/IBaseComponent';
import IDateComponent from '@components/FormFlow/Interfaces/FormflowComponents/IDateComponent';
import FormflowContext from '@components/FormFlow/Util/FormflowContext';
import { ComponentType } from '@interfaces/component-type';
import AppContext from '@services/Context';
import NotificationComponent from '@src/helpers/_showNotifications';
import I18n from '@src/i18n';
import { Theme } from '@src/styled-components';
import { Button, DatePicker, Radio, Row } from 'antd';
import pt_BR from 'antd/lib/locale-provider/pt_BR';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';

import { InstructionTaskComponent } from '../TextInstructionComponent';

const RadioGroup = Radio.Group;
interface IDateTaskComponentStateType {
  instructionTitle: string;
  required: boolean;
  description?: string;
  repeat: boolean;
  minRepeat: number;
  maxRepeat: number;
  convertingDateMin: any;
  convertingDateMax: any;
  useToday: boolean;
  useTodayMax: boolean;
};

export class DateComponent implements IDateComponent {
  id: string;
  required: boolean;
  type: ComponentType;
  title: string;
  description?: string;
  repeat: boolean;
  minRepeat: number;
  maxRepeat: number;
  min: number | undefined;
  max: number | undefined;
  useToday: boolean;
  useTodayMax: boolean;

  constructor(id: string = '') {
    this.id = id;
    this.required = false;
    this.type = ComponentType.DATE;
    this.title = '';
    this.repeat = false;
    this.minRepeat = 0;
    this.maxRepeat = 0;
    this.min = Date.now();
    this.max = Date.now();
    this.useToday = false;
    this.useTodayMax = false;
    return this;
  }
}
export default class DateTaskComponent extends React.Component<IDateComponent, IDateTaskComponentStateType> {

  constructor(props: IDateComponent) {
    super(props);
    this.state = {
      instructionTitle: '',
      description: this.props.description || undefined,
      required: this.props.required || false,
      repeat: this.props.repeat || false,
      convertingDateMin: this.props.min,
      convertingDateMax: this.props.max,
      useToday: this.props.useToday || false,
      useTodayMax: this.props.useTodayMax || false,
      minRepeat: this.props.minRepeat,
      maxRepeat: this.props.maxRepeat,
    };
  }
  componentDidMount() {
    this.setState({ instructionTitle: this.props.title !== undefined ? this.props.title : '' })
  }
  handleIntructionTitleChange = async (evt: any) => {
    this.setState({ instructionTitle: evt.target.value });
  }

  handleDescriptionChange = async (evt: any) => {
    this.setState({ description: evt.target.value });
  }

  handleRequiredChange = async (evt: any) => {
    this.setState({ required: evt.target.checked });
  }

  handleRepeatChange = async (evt: any) => {
    this.setState({ repeat: evt.target.checked });
  }

  handleRepeatMinChange = async (evt: any) => {
    this.setState({ minRepeat: evt });
  }
  handleRepeatMaxChange = async (evt: any) => {
    this.setState({ maxRepeat: evt });
  }

  onRadioChangeMin = async (evt: any) => {
    if (evt.target.value === true) {
      this.setState({
        useToday: evt.target.value,
        convertingDateMin: null
      })
    }
    else {
      this.setState({ useToday: false })
    }
  }
  onRadioChangeMax = async (evt: any) => {
    if (evt.target.value === true) {
      this.setState({
        useTodayMax: evt.target.value,
      })
    }
    else {
      this.setState({ useTodayMax: false })
    }
  }

  onChangeDateMin = async (date: any) => {
    const newDate = date.toDate().getTime()
    this.setState({ convertingDateMin: newDate })
  }

  onChangeDateMax = async (date: any) => {
    try {
      const newDate = date.toDate().getTime()
      this.setState({ convertingDateMax: newDate })
    } catch (error) {
      this.setState({ convertingDateMax: undefined })
    }
  }

  async onSubmitDateComponent(updateFormflowWithComponent: (component: IBaseComponent) => void) {
    if (this.state.convertingDateMax < this.state.convertingDateMin) {
      return NotificationComponent.Notify('error', I18n.l("common.error"), I18n.l("formflow.components.dateComponent.validatioMinMax"));
    }
    
    else {
      if(this.state.useToday) {
        this.setState({convertingDateMin : null})
      }
      if(this.state.useTodayMax ){
        this.setState({convertingDateMax : null})
      }
      const newPhotoDataComponent: IDateComponent = {
        id: this.props.id,
        type: ComponentType.DATE,
        title: this.state.instructionTitle,
        description: this.state.description,
        required: this.state.required,
        repeat: this.state.repeat,
        minRepeat: this.state.minRepeat,
        maxRepeat: this.state.maxRepeat,
        min: this.state.convertingDateMin,
        max: this.state.convertingDateMax,
        useToday: this.state.useToday,
        useTodayMax: this.state.useTodayMax
      }
      updateFormflowWithComponent(newPhotoDataComponent);
    }
  }

  render() {
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    };

    const {
      instructionTitle,
      required,
      repeat,
      convertingDateMax,
      convertingDateMin,
    } = this.state
    return (
      <AppContext.Consumer>
        {({ locale }) => (
          <Wrapper>
            <InstructionTaskComponent
              visibleDescription={true}
              inputDescriptionValue={this.props.description != undefined ? this.props.description : ''}
              conditionsTaskComponents={true}
              inputTitleValue={instructionTitle}
              repeatCheckedValue={repeat}
              requiredCheckedValue={required}
              onInputInstructionChange={() => this.handleIntructionTitleChange}
              onChangeDescription={() => this.handleDescriptionChange}
              onChangeRequiredCheckbox={() => this.handleRequiredChange}
              onChangeRepeatCheckbox={() => this.handleRepeatChange}
              onChangeRepeatMin={this.handleRepeatMinChange}
              onChangeRepeatMax={this.handleRepeatMaxChange}
              valueRepeatMin={this.state.minRepeat}
              valueRepeatMax={this.state.maxRepeat}
              titleComponent={I18n.l("formflow.components.dateComponent.titleDateComponent")}
              descriptionComponent={I18n.l("formflow.components.dateComponent.descriptionDateComponent")}
              exampleDescriptionComponent={I18n.l("formflow.components.dateComponent.exampleDescriptionDateComponent")}
              checkboxtTaskPerform={true}
              titleCheckboxtTaskPerform={I18n.l("formflow.components.dateComponent.titleCheckboxtTaskPerformDateComponent")}
              titleRepeatMin={I18n.l("formflow.components.dateComponent.titleRepeatMin")}
              titleRepeatMax={I18n.l("formflow.components.dateComponent.titleRepeatMax")}
            />
            <DividerBorder />
            <p className="optional-validation-condition-text" >
              {I18n.l("formflow.labels.optionalValidationComponents")}
            </p>
            <div className="text-radio-validation" >
              <RadioGroup onChange={this.onRadioChangeMin} defaultValue={this.props.useToday ? this.props.useToday : this.props.min} >
                <Radio style={radioStyle} value={convertingDateMin} >{I18n.l("formflow.components.dateComponent.minDateAcceptable")}
                  <DatePicker
                    format={I18n.l('common.dateFormat')}
                    locale={(locale === "pt") ? pt_BR.DatePicker : undefined}
                    onChange={this.onChangeDateMin}
                    defaultValue={this.props.min ?  moment(convertingDateMin) : undefined}
                    className="text-date-validation"
                    placeholder={I18n.l('label.datePlaceholder')}
                  />
                </Radio>
                <Radio style={radioStyle} value={true}>{I18n.l("formflow.components.dateComponent.minDateAcceptableToday")}</Radio>
              </RadioGroup >
            </div>
            <DividerBorder />
            <div style={{ marginTop: '2rem' }} className="text-radio-validation">
              <RadioGroup onChange={this.onRadioChangeMax} defaultValue={this.props.useTodayMax ? this.props.useTodayMax : this.props.max} >
                <Radio style={radioStyle} value={convertingDateMax}>{I18n.l("formflow.components.dateComponent.maxDateAcceptable")}
                  {I18n.l("formflow.components.dateComponent.maxDateAcceptable")}
                  <DatePicker
                    format={I18n.l('common.dateFormat')}
                    locale={(locale === "pt") ? pt_BR.DatePicker : undefined}
                    onChange={this.onChangeDateMax}
                    defaultValue={this.props.max && this.props.max !== 3685392000000 ? moment(convertingDateMax) : undefined}
                    className="text-date-validation"
                    placeholder={I18n.l('label.datePlaceholder')}
                  />
                </Radio>
                <Radio style={radioStyle} value={true}>{I18n.l("formflow.components.dateComponent.maxDateAcceptableToday")}</Radio>
              </RadioGroup >
            </div>
            <FormflowContext.Consumer>
              {({ destroyComponentModalWindow, updateFormflowWithComponent }) => (
                <div>
                  <ButtonStyle>
                    <Row type="flex" justify="end">
                      <Button className="button-cancel" type="primary" onClick={destroyComponentModalWindow} ghost>{I18n.l('common.cancel')}</Button>
                      <Button className="button-save" type="primary"
                        disabled={instructionTitle.length === 0 ||
                          instructionTitle.length < 3 ||
                          this.state.convertingDateMin === undefined ||
                          this.state.convertingDateMax === undefined ? true : false}
                        onClick={() => { this.onSubmitDateComponent(updateFormflowWithComponent) }} >
                        {I18n.l('common.save')}
                      </Button>
                    </Row>
                  </ButtonStyle>
                </div>
              )}
            </FormflowContext.Consumer>
          </Wrapper>
        )}
      </AppContext.Consumer>
    );
  }
}
const Wrapper = styled.div`
    width:100%;
    margin-bottom: 2rem;
    .optional-validation-condition-text{
        font-weight: bold;
        margin-top: 2rem;
        margin-bottom: 2rem;
        margin-left: 3rem;
        margin-right: 3rem;
    }
    .text-radio-validation{
        width:50%;
        margin-top: 1rem;
        margin-left: 3rem;
        margin-right: 3rem;
    }
    .text-date-validation{
        width: 150px;
        margin-left: 5px;
        margin-right: 5px;
        text-align: center;
    }

`
const ButtonStyle = styled.div`
    float:right;
    margin-top: 5vh;
    margin-bottom: 5vh;
    margin-right: 50px;
    
    .button-save{
        bottom: 5%;
        width: 6rem;
    }
    .button-cancel{
        bottom: 5%;
        width: 6rem;
        margin-left: -6.5rem;
    }
`;

const DividerBorder = styled.div`
    margin-top: 2rem;
    margin-left: 3rem;
    margin-right: 3rem;   
    border-bottom: 1px solid ${Theme.secondary.midGrey};
`